import Button from '@material-ui/core/Button';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import React, { useEffect, useState } from 'react';
import { useObservable } from 'react-use-observable';
import { warningsFactory } from 'v2/services/warning';

import NoDangerouslyHTML from '../NoDangerouslyHTML';

const GlobalWarning = () => {
  useObservable(() => warningsFactory.loadGlobalWarnings(), []);

  const [answeredWarnings, setAnsweredWarnings] = useState([]);
  const [warnings] = useObservable(() => warningsFactory.getWarnings(), []);

  const warningsNotAnswered = warnings?.filter((warning) => !answeredWarnings.includes(warning.id)) || [];

  const closeAlert = (id: string) => {
    const newAnsweredWarnings = [...answeredWarnings, id];
    localStorage.setItem('warnings', newAnsweredWarnings.toString());
    setAnsweredWarnings(newAnsweredWarnings);
  };

  useEffect(() => {
    const storage = localStorage.getItem('warnings');
    setAnsweredWarnings(storage?.split(',') || []);
  }, []);

  if (!warningsNotAnswered?.length) return null;

  return (
    <>
      {warningsNotAnswered.map((warning) => (
        <>
          <Alert
            key={warning.id}
            severity='warning'
            action={
              <>
                {!!warning.link && (
                  <Button target='_blank' href={warning.link} color='primary' variant='outlined' aria-label='saiba mais'>
                    Saiba mais
                  </Button>
                )}
                &nbsp;
                <Button color='primary' variant='outlined' onClick={() => closeAlert(warning.id)} aria-label='fechar'>
                  Entendi
                </Button>
              </>
            }
          >
            <AlertTitle>{warning.title} </AlertTitle>
            <NoDangerouslyHTML html={warning.description} />
          </Alert>
          <div className='m16' />
        </>
      ))}
    </>
  );
};

export default GlobalWarning;
